<template>
  <mmp-modal v-bind="componentAttrs" title="개인정보 처리방침" v-on="listeners">

    <template v-slot:header>
      <div class="popup_title">
        개인정보 처리방침
      </div>
      <button type="button" class="btn_close" @click="$emit('close')"><span class="blind">팝업 닫기</span></button>
    </template>

    <template v-slot:content>
      <div class="notice_box">
        <div
          v-dompurify-html="rawHtml" v-mmp-scroll id="agreebox-wrap"
          ref="dynamicHtml"
          class="agreebox-wrap"/>
      </div>
      <div class="select_box">
        <select v-model="histListSeleted" title="시행일자 기준" >
          <option
            v-for="(histListObj, idx) in histList" :key="idx"
            :value="histListObj.value">
            {{ histListObj.tit }}
          </option>
        </select>
    </div></template>
    <template v-slot:footer><div/></template>
  </mmp-modal>
</template>

<script>
import { isEmpty, map, forEach } from 'lodash'
import Vue from 'vue'

export default {
  name: 'MmpPrivacyPolicy',
  directives: {
    mmpScroll: {
      bind (el, binding, vnode) {
      },
      inserted (el, binding, vnode) {
      },
      update (el, binding, vnode) {
        var hrefElmList = el.querySelectorAll('.agree-link > ul > li > a')

        var containerSelector = '.notice_box'
        if (hrefElmList && hrefElmList.length > 0) {
          forEach(hrefElmList, function (elm) {
            var parentLiElm = elm.parentNode
            var hashHref = elm.getAttribute('href')

            var ScrollToComponent = Vue.extend({
              template: '<a v-scroll-to="{el:\'' + hashHref + '\', container: \'' + containerSelector + '\' }" href="javascript:void(0)">' + elm.textContent + '</a>'
            })

            var appendCmp = new ScrollToComponent().$mount()
            parentLiElm.appendChild(appendCmp.$el)
            parentLiElm.removeChild(elm)
          })
        }
        console.log('mmpScroll update: ' )
      },
      unbind (el, binding, vnode) {
        console.log('mmpScroll unbind')
      }
    }
  },
  mixins: [
  ],
  data () {
    return {
      rawHtml: '',
      histListStr: '',
      histListSeleted: ''
    }
  },
  computed: {
    isValidParam () {
      return true
    },
    histList () {
      if (isEmpty(this.histListStr)) {
        return []
      }

      var rtList = map(this.histListStr.split('|'), function (val, idx) {
        return {
          tit: val.split('^')[0],
          value: val.split('^')[1]
        }
      })

      return rtList
    }
  },
  watch: {
    'histListSeleted': {
      handler: function (nval, oval) {
        if (nval !== oval) {
          this.getPrivacyPolicyTerms(this.histListSeleted)
        }
      }
    }
  },
  created () {
  },
  mounted () {
    this.getPrivacyPolicyTerms()
  },
  methods: {
    async getPrivacyPolicyTerms (termsAgrmtSno) {
      var params = {}

      if (!isEmpty(termsAgrmtSno)) {
        params.termsAgrmtSno = termsAgrmtSno
      }

      var getPrivacyPolicyTermsResult = await this.$http.busn.getPrivacyPolicyTerms(this, params)

      if (getPrivacyPolicyTermsResult.data.status === 'OK') {
        this.$set(this, 'rawHtml', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.termsCntnt )
        if (isEmpty(this.histListSeleted)) {
          this.$set(this, 'histListSeleted', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.histList.split('|')[0].split('^')[1])
        }
        this.$set(this, 'histListStr', getPrivacyPolicyTermsResult.data.data.privacyPolicyTerms.histList )
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/MmpPrivacyPolicy.vue